import styled from '@emotion/styled';
import { compose, display, color, space, variant, gridArea, textAlign, } from 'styled-system';
import css from '@styled-system/css';
const baseCss = css({
    fontFamily: 'body',
    m: 0,
});
export const Text = styled.p `
  ${baseCss}

  ${({ theme }) => compose(display, color, space, textAlign, gridArea, variant({
    variants: theme.textVariants,
}))}
`;
Text.defaultProps = {
    variant: 'default',
    color: 'text',
};
export const H1 = styled(Text) ``;
H1.defaultProps = {
    as: 'h1',
    variant: 'xl',
    color: 'text',
};
export const H2 = styled(Text) ``;
H2.defaultProps = {
    as: 'h2',
    color: 'text',
};
export const H3 = styled(Text) ``;
H3.defaultProps = {
    as: 'h3',
    color: 'text',
};
export const H4 = styled(Text) ``;
H4.defaultProps = {
    as: 'h4',
    color: 'text',
};
export const H5 = styled(Text) ``;
H5.defaultProps = {
    as: 'h5',
    color: 'text',
};
export const H6 = styled(Text) ``;
H6.defaultProps = {
    as: 'h6',
    color: 'text',
};
export const P = styled(Text) ``;
P.defaultProps = {
    as: 'p',
    color: 'text',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3RleHQvVGV4dC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxNQUFNLE1BQU0saUJBQWlCLENBQUM7QUFDckMsT0FBTyxFQUNMLE9BQU8sRUFDUCxPQUFPLEVBQ1AsS0FBSyxFQUNMLEtBQUssRUFDTCxPQUFPLEVBQ1AsUUFBUSxFQUNSLFNBQVMsR0FLVixNQUFNLGVBQWUsQ0FBQztBQUN2QixPQUFPLEdBQUcsTUFBTSxvQkFBb0IsQ0FBQztBQWtDckMsTUFBTSxPQUFPLEdBQUcsR0FBRyxDQUFDO0lBQ2xCLFVBQVUsRUFBRSxNQUFNO0lBQ2xCLENBQUMsRUFBRSxDQUFDO0NBQ0wsQ0FBQyxDQUFDO0FBRUgsTUFBTSxDQUFDLE1BQU0sSUFBSSxHQUFHLE1BQU0sQ0FBQyxDQUFDLENBQVc7SUFDbkMsT0FBTzs7SUFFUCxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUNkLE9BQU8sQ0FDTCxPQUFPLEVBQ1AsS0FBSyxFQUNMLEtBQUssRUFDTCxTQUFTLEVBQ1QsUUFBUSxFQUNSLE9BQU8sQ0FBQztJQUNOLFFBQVEsRUFBRSxLQUFLLENBQUMsWUFBWTtDQUM3QixDQUFDLENBQ0g7Q0FDSixDQUFDO0FBRUYsSUFBSSxDQUFDLFlBQVksR0FBRztJQUNsQixPQUFPLEVBQUUsU0FBUztJQUNsQixLQUFLLEVBQUUsTUFBTTtDQUNkLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxFQUFFLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFBLEVBQUUsQ0FBQztBQUNqQyxFQUFFLENBQUMsWUFBWSxHQUFHO0lBQ2hCLEVBQUUsRUFBRSxJQUFJO0lBQ1IsT0FBTyxFQUFFLElBQUk7SUFDYixLQUFLLEVBQUUsTUFBTTtDQUNkLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxFQUFFLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFBLEVBQUUsQ0FBQztBQUNqQyxFQUFFLENBQUMsWUFBWSxHQUFHO0lBQ2hCLEVBQUUsRUFBRSxJQUFJO0lBQ1IsS0FBSyxFQUFFLE1BQU07Q0FDZCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sRUFBRSxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQSxFQUFFLENBQUM7QUFDakMsRUFBRSxDQUFDLFlBQVksR0FBRztJQUNoQixFQUFFLEVBQUUsSUFBSTtJQUNSLEtBQUssRUFBRSxNQUFNO0NBQ2QsQ0FBQztBQUNGLE1BQU0sQ0FBQyxNQUFNLEVBQUUsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUEsRUFBRSxDQUFDO0FBQ2pDLEVBQUUsQ0FBQyxZQUFZLEdBQUc7SUFDaEIsRUFBRSxFQUFFLElBQUk7SUFDUixLQUFLLEVBQUUsTUFBTTtDQUNkLENBQUM7QUFDRixNQUFNLENBQUMsTUFBTSxFQUFFLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFBLEVBQUUsQ0FBQztBQUNqQyxFQUFFLENBQUMsWUFBWSxHQUFHO0lBQ2hCLEVBQUUsRUFBRSxJQUFJO0lBQ1IsS0FBSyxFQUFFLE1BQU07Q0FDZCxDQUFDO0FBQ0YsTUFBTSxDQUFDLE1BQU0sRUFBRSxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQSxFQUFFLENBQUM7QUFDakMsRUFBRSxDQUFDLFlBQVksR0FBRztJQUNoQixFQUFFLEVBQUUsSUFBSTtJQUNSLEtBQUssRUFBRSxNQUFNO0NBQ2QsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLENBQUMsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUEsRUFBRSxDQUFDO0FBQ2hDLENBQUMsQ0FBQyxZQUFZLEdBQUc7SUFDZixFQUFFLEVBQUUsR0FBRztJQUNQLEtBQUssRUFBRSxNQUFNO0NBQ2QsQ0FBQyJ9